// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1sZok","col":"styles_col__FSDhW","fulfillmentStatus":"styles_fulfillmentStatus__2BR0-","emailCol":"styles_emailCol__IfjC6"};